import axios from "config/axios";
import { Address, GenericPageResponse } from "shared/types";

const ENDPOINT = "/rel-shipment-address";

export type RelShipmentAddress = {
  id: number;
  shipmentId: number;
  address: Address;
  addressType: string;
  createdBy: number;
  updatedBy: number;
};

export const getRelShipmentAddressPage = (page: number, size: number, search: string) =>
  axios.get<GenericPageResponse<RelShipmentAddress>>(
    `${ENDPOINT}/get-page?page=${page}&size=${size}&search=${search}`,
  );
